'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _NameInput = require('./components/NameInput.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_NameInput).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/name-input/index.js
// module id = 1049
// module chunks = 0